import React, { Component } from 'react';
import '../../css/surwey_area.style.css';
import { Row, Col } from 'react-bootstrap';
import data from './data.json';
import RadarChart from 'react-svg-radar-chart';
import 'react-svg-radar-chart/build/css/index.css'
import './style.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
export class index extends Component {
    constructor(props) {
        super(props);
        this.state = {

            // ans: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
            //     1, 1, 1, 1, 1
            // ],
            ans: [null, null, null, null, null, null, null, null, null, null,
                null, null, null, null, null
            ],
            submit: false,
            result: [],
            data: [],
            captions: [],
            cc: false,

            // สถิติคดี
            Sex: '',
            Age: '',
            Time: '',
            VictimSex: '',
            VictimAge: '',
            WrongType: '',
            Locale: '',
            Locale_an: null,
            dataType: ['ชีวิต/ร่างกาย', 'ทรัพย์สิน', 'เพศ (ข่มขืน กระทำชำเรา อนาจาร คุกคามทางเพศ)', 'รัฐเป็นผู้เสียหาย (ยาเสพติด การพนัน อาวุธปืน)']


        }
    }
    componentDidMount() {
        console.log("staert")
    }
    onChangeValue(index, value) {
        const temp = this.state.ans;
        temp[index] = value;
        this.setState({
            ans: temp
        })

    }
    handleChange = (event) => {
        event.preventDefault();
        this.setState({ Locale: event.target.value });
    }

    check1() {
        const tempans = this.state.ans;
        var check = true;
        tempans.forEach(element => {
            if (element === null) {
                check = false
            }
        })
        if (check) {
            this.setState({
                cc: true
            })
        } else {
            confirmAlert({
                title: 'กรอกข้อมูลไม่ครบ',
                message: ' กรุณาเลือกข้อมูลมั้งหมดทุกข้อ',
                closeOnClickOutside: true,
                buttons: [
                    {
                        label: 'ตกลง',

                    },

                ]
            });
        }

    }
    onSubmit = (e) => {
        e.preventDefault();
        var local = [0, 0, 0, 0, 0];
        var count = 0;
        var result = [];
        var data = '';
        var captions = '';
        var result_text = ["เมือง", "อุตสาหกรรม", "ท่องเที่ยว", "เกษตรกรรม", "ชายแดน"]
        for (let index = 0; index < this.state.ans.length; index++) {
            local[count] += this.state.ans[index];
            if ((index + 1) % 3 === 0) {
                count++;
            }
        }

        var vmax = Math.max(...local);
        console.log(vmax)
        for (let i = 0; i < 5; i++) {

            if (local[i] === vmax) {
                result.push({
                    value: "ชุมชน" + result_text[i]
                })
            }
        }
        data = {
            local1: local[0] * 0.1,
            local2: local[1] * 0.1,
            local3: local[2] * 0.1,
            local4: local[3] * 0.1,
            local5: local[4] * 0.1,
        }
        captions = {

            local1: "เมือง",
            local2: "อุตสาหกรรม",
            local3: "ท่องเที่ยว",
            local4: "เกษตรกรรม",
            local5: "ชายแดน",

        }
        console.log(local)
        this.setState({
            submit: true,
            result,
            data,
            captions
        })
    }

    render() {
        const { Sex, Age, Time, VictimSex, VictimAge, WrongType, Locale } = this.state;
        return (
            <div className="mainArea">
                <div style={{ padding: 20 }}>


                    <h1 style={{ textAlign: 'center', marginBottom: 10, color: '#ffffff' }} className="baseText">
                        {this.state.submit ? "บริบทชุมชนของคุณ คือ" : "แบบประเมินบริบทของพื้นที่"}
                    </h1>

                    <hr></hr>
                    {this.state.submit ?
                        <div>
                            <Row style={{ padding: 10 }}>
                                <Col>
                                    <div className="boxcard" >
                                        {this.state.result.map((element, i) =>
                                            <div key={i} style={{ marginLeft: 20 }}>
                                                <li style={{ fontSize: 20 }}>{element.value}</li>
                                            </div>

                                        )}
                                    </div>

                                    <hr></hr>
                                    <div className="boxcard">
                                        <h4>สถิติอาชญากรรม</h4>
                                        <div style={{ marginLeft: 20 }}>
                                            <h6>ผู้กระทำความผิด เพศ {Sex} อายุ {Age}</h6>
                                            <h6>ช่วงเวลาเกิดเหตุ {Time}</h6>
                                            <h6>สถานที่เกิดเหตุ {Locale}</h6>
                                            <h6>เหยื่อเป็น เพศ {VictimSex} อายุ {VictimAge}</h6>
                                            <h6>ประเภทความผิด {this.state.dataType[WrongType]}</h6>
                                        </div>
                                    </div>
                                    <div className="boxcard">
                                        <h4>โครงการพื้นฐาน</h4>
                                    </div>
                                    {this.state.result.map((element, i) =>
                                        element.value === "ชุมชนเมือง" ?
                                            (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                <div>
                                                    <p>BS01 - โครงการแผนที่อาชญากรรม</p>
                                                    <p>BS04 - โครงการลดเสี่ยง เลี่ยงอาชญากรรม</p>
                                                    <p>BS06 - โครงการพัฒนาศักยภาพในการป้องกันอาชญากรรม</p>
                                                </div>
                                            </div>)
                                            :
                                            element.value === "ชุมชนอุตสาหกรรม" ?
                                                (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                    <div>
                                                        <p>BS01 - โครงการแผนที่อาชญากรรม</p>
                                                        <p>BS02 - โครงการอาสาสมัครเตือนภัยอาชญากรรม</p>
                                                        <p>BS04 - โครงการลดเสี่ยง เลี่ยงอาชญากรรม</p>
                                                        <p>BS06 - โครงการพัฒนาศักยภาพในการป้องกันอาชญากรรม</p>

                                                    </div>
                                                </div>)
                                                : element.value === "ชุมชนท่องเที่ยว" ?
                                                    (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                        <div>
                                                            <p>BS01 - โครงการแผนที่อาชญากรรม</p>
                                                            <p>BS04 - โครงการลดเสี่ยง เลี่ยงอาชญากรรม</p>
                                                            <p>BS05 - โครงการจัดทำสื่อประชาสัมพันธ์ป้องกันภัยอาชญากรรม</p>
                                                            <p>BS06 - โครงการพัฒนาศักยภาพในการป้องกันอาชญากรรม</p>
                                                        </div>
                                                    </div>)
                                                    : element.value === "ชุมชนเกษตรกรรม" ?
                                                        (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                            <div>
                                                                <p>BS01 - โครงการแผนที่อาชญากรรม</p>
                                                                <p>BS02 - โครงการอาสาสมัครเตือนภัยอาชญากรรม</p>
                                                                <p>BS03 - โครงการบ้านอบอุ่น เติมทุนชีวิต</p>
                                                                <p>BS06 - โครงการพัฒนาศักยภาพในการป้องกันอาชญากรรม</p>
                                                            </div>
                                                        </div>)
                                                        :
                                                        (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                            <div>
                                                                <p>BS01 - โครงการแผนที่อาชญากรรม</p>
                                                                <p>BS02 - โครงการอาสาสมัครเตือนภัยอาชญากรรม</p>
                                                                <p>BS06 - โครงการพัฒนาศักยภาพในการป้องกันอาชญากรรม</p>
                                                            </div>
                                                        </div>)

                                    )}
                                </Col>

                                <Col>
                                    <RadarChart
                                        captions={this.state.captions}
                                        data={[
                                            // data
                                            {
                                                data: this.state.data,
                                                meta: { color: '#ff0000' }
                                            },
                                        ]}

                                        size={300}
                                    />
                                    <div className="boxcard"> <h4>โครงการตามบริบทพื้นที่</h4></div>

                                    {this.state.result.map((element, i) =>
                                        element.value === "ชุมชนเมือง" ?
                                            (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                <li style={{ fontSize: 20 }}>{element.value}</li>
                                                <div>
                                                    <p>A01 - โครงการลดสุ่มเสี่ยง เพิ่มสร้างสรรค์ ชุมชนร่วมใจพัฒนา</p>
                                                    <p>A02 - โครงการเชื่อมโยงเครือข่ายกล้องวงจรปิด</p>
                                                    <p>A03 - โครงการ Safety Box</p>
                                                    <p>A04 - โครงการกลับบ้านปลอดภัย</p>
                                                    <p>A05 - โครงการให้ความรู้เรื่องอาชญากรรมรูปแบบใหม่</p>
                                                </div>
                                            </div>)
                                            :
                                            element.value === "ชุมชนอุตสาหกรรม" ?
                                                (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                    <li style={{ fontSize: 20 }}>{element.value}</li>
                                                    <div>
                                                        <p>A01 - โครงการลดสุ่มเสี่ยง เพิ่มสร้างสรรค์ ชุมชนร่วมใจพัฒนา</p>
                                                        <p>A02 - โครงการเชื่อมโยงเครือข่ายกล้องวงจรปิด</p>
                                                        <p>A03 - โครงการ Safety Box</p>
                                                        <p>B01 - โครงการอบรมทักษะการป้องกันตัว</p>
                                                        <p>B02 - โครงการป้องกันภัย อุ่นใจยามวิกาล</p>

                                                    </div>
                                                </div>)
                                                : element.value === "ชุมชนท่องเที่ยว" ?
                                                    (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                        <li style={{ fontSize: 20 }}>{element.value}</li>
                                                        <div>
                                                            <p>A01 - โครงการลดสุ่มเสี่ยง เพิ่มสร้างสรรค์ ชุมชนร่วมใจพัฒนา</p>
                                                            <p>A02 - โครงการเชื่อมโยงเครือข่ายกล้องวงจรปิด</p>
                                                            <p>C01 - โครงการชุมชนท่องเที่ยวปลอดภัย</p>
                                                            <p>C02 - โครงการท่องเที่ยวอุ่นใจไร้อาชญากรรม</p>
                                                            <p>C03 - โครงการเครือข่ายYouth Guide ป้องกันภัยอาชญากรรม</p>
                                                            <p>C04 - โครงการผลิตสื่อแนะนำนักท่องเที่ยว “เที่ยวอย่างปลอดภัยไม่กังวลใจ”</p>
                                                        </div>
                                                    </div>)
                                                    : element.value === "ชุมชนเกษตรกรรม" ?
                                                        (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                            <li style={{ fontSize: 20 }}>{element.value}</li>
                                                            <div>
                                                                <p>D01 - โครงการเพื่อนบ้านเตือนภัย</p>
                                                                <p>D02 - โครงการให้ความรู้แก่เด็กและผู้สูงอายุไม่ให้ตกเป็นเหยื่อ “รู้ไว้ไม่โดนหลอก”</p>
                                                                <p>D03 - โครงการ บ ว ร ร่วมใจ (บ้าน วัด โรงเรียน)</p>
                                                            </div>
                                                        </div>)
                                                        :
                                                        (<div key={i} style={{ marginLeft: 20 }} className="boxcard">
                                                            <li style={{ fontSize: 20 }}>{element.value}</li>
                                                            <div>
                                                                <p>E01 - โครงการสานสัมพันธ์ รวมใจกัน ป้องกันภัย</p>
                                                                <p>E02 - โครงการเครือข่ายเด็กและเยาวชนป้องกันการค้ามนุษย์</p>
                                                                <p>E03 - โครงการป้องกันและแก้ไขปัญหาความรุนแรงต่อเด็กและสตรี</p>
                                                                <p>E04 - โครงการรั้วบ้านล้อมภัย</p>
                                                            </div>
                                                        </div>)

                                    )}
                                </Col>

                            </Row>
                        </div>


                        : <form onSubmit={this.onSubmit}>
                            {this.state.cc &&
                                <div>
                                    <div style={{ justifyContent: 'center', }}>
                                        <h2 style={{ color: '#ffffff' }}>ข้อมูลสถิติอาชญากรรมในชุมชน</h2>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 26, marginTop: 10 }}>ผู้กระทำความผิด</p>

                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านผู้กระทำผิดส่วนใหญ่เป็นเพศใด</label>
                                            <div >
                                                <input type="radio" id="male" name="gender" value={Sex} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Sex: 'ชาย' })} autoFocus />
                                                <label style={{ marginRight: 10 }}>ชาย</label>
                                                <input type="radio" id="female" name="gender" value={Sex} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Sex: 'หญิง' })} />
                                                <label>หญิง</label>
                                            </div>
                                        </div>

                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านผู้กระทำผิดส่วนใหญ่อยู่ในช่วงอายุใด </label>
                                            <div >
                                                <input type="radio" id="y0006" name="age" value={Age} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Age: '0 - 6 ปี' })} />
                                                <label style={{ marginRight: 10 }}>0 - 6 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y0612" name="age" value={Age} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Age: '6 - 12 ปี' })} />
                                                <label style={{ marginRight: 10 }}>6 - 12 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y1218" name="age" value={Age} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Age: '12 - 18 ปี' })} />
                                                <label style={{ marginRight: 10 }}>12 - 18 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y1835" name="age" value={Age} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Age: '18 - 35 ปี' })} />
                                                <label style={{ marginRight: 10 }}>18 - 35 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y3560" name="age" value={Age} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Age: '35 - 60 ปี' })} />
                                                <label style={{ marginRight: 10 }}>35 - 60 ปี</label>
                                            </div>
                                        </div>
                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านผู้กระทำผิดก่อเหตุในช่วงเวลาใด</label>
                                            <div >
                                                <input type="radio" id="t0005" name="time" value={Time} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Time: '00.00 - 05.00' })} />
                                                <label style={{ marginRight: 10 }}>00.00 - 05.00</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="t0510" name="time" value={Time} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Time: '05.00 - 10.00' })} />
                                                <label style={{ marginRight: 10 }}>05.00 - 10.00</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="t1015" name="time" value={Time} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Time: '10.00 - 15.00' })} />
                                                <label style={{ marginRight: 10 }}>10.00 - 15.00</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="t1520" name="time" value={Time} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Time: '15.00 - 20.00' })} />
                                                <label style={{ marginRight: 10 }}>15.00 - 20.00</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="t2000" name="time" value={Time} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Time: '20.00 - 00.00' })} />
                                                <label style={{ marginRight: 10 }}>20.00 - 00.00</label>
                                            </div>
                                        </div>

                                        <p style={{ fontSize: 26, marginTop: 10 }}>ผู้ถูกกระทำ(เหยื่อ)</p>
                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านเหยื่อส่วนใหญ่เป็นเพศใด</label>
                                            <div >
                                                <input type="radio" id="male" name="Victimgender" value={VictimSex} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimSex: 'ชาย' })} />
                                                <label style={{ marginRight: 10 }}>ชาย</label>
                                                <input type="radio" id="female" name="Victimgender" value={VictimSex} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimSex: 'หญิง' })} />
                                                <label>หญิง</label>
                                            </div>
                                        </div>
                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านเหยื่อส่วนใหญ่อยู่ในช่วงอายุใด</label>
                                            <div >
                                                <input type="radio" id="y0006" name="VictimAgeage" value={VictimAge} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimAge: '0 - 6 ปี' })} />
                                                <label style={{ marginRight: 10 }}>0 - 6 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y0612" name="VictimAgeage" value={VictimAge} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimAge: '6 - 12 ปี' })} />
                                                <label style={{ marginRight: 10 }}>6 - 12 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y1218" name="VictimAgeage" value={VictimAge} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimAge: '12 - 18 ปี' })} />
                                                <label style={{ marginRight: 10 }}>12 - 18 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y1835" name="VictimAgeage" value={VictimAge} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimAge: '18 - 35 ปี' })} />
                                                <label style={{ marginRight: 10 }}>18 - 35 ปี</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="y3560" name="VictimAgeage" value={VictimAge} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ VictimAge: '35 - 60 ปี' })} />
                                                <label style={{ marginRight: 10 }}>35 - 60 ปี</label>
                                            </div>
                                        </div>
                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 22 }}>
                                                ในพื้นที่ของท่านส่วนใหญ่มีลักษณะของการกระทำความผิดแบบใด</label>
                                            <div >
                                                <input type="radio" id="w1" name="Wrongtype" value={WrongType} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ WrongType: 0 })} />
                                                <label style={{ marginRight: 10 }}>ชีวิต/ร่างกาย</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="w2" name="Wrongtype" value={WrongType} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ WrongType: 1 })} />
                                                <label style={{ marginRight: 10 }}>ทรัพย์สิน</label>
                                            </div>
                                            <div>

                                                <input type="radio" id="w3" name="Wrongtype" value={WrongType} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ WrongType: 2 })} />
                                                <label style={{ marginRight: 10 }}>เพศ (ข่มขืน กระทำชำเรา อนาจาร คุกคามทางเพศ)</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="w4" name="Wrongtype" value={WrongType} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ WrongType: 3 })} />
                                                <label style={{ marginRight: 10 }}>รัฐเป็นผู้เสียหาย (ยาเสพติด การพนัน อาวุธปืน)</label>
                                            </div>
                                        </div>
                                        <div className="boxcard">
                                            <label htmlFor="defaultFormLoginEmailEx" style={{ marginRight: 10, fontSize: 26 }}>
                                                ในพื้นที่ของท่านส่วนใหญ่สถานที่เกิดเหตุอยู่ที่ไหน </label>
                                            <div >
                                                <input type="radio" id="Locale1" name="Locale" value={Locale} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Locale: 'บ้าน', local_an: null })} />
                                                <label style={{ marginRight: 10 }}>บ้าน</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="Locale2" name="Locale" value={Locale} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Locale: 'ที่ทำงาน', local_an: null })} />
                                                <label style={{ marginRight: 10 }}>ที่ทำงาน</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="Locale3" name="Locale" value={Locale} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Locale: 'สถานที่สาธารณะ', local_an: null })} />
                                                <label style={{ marginRight: 10 }}>สถานที่สาธารณะ</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="Locale4" name="Locale" value={Locale} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Locale: 'โรงเรียนหรือสถาบันการศึกษา', local_an: null })} />
                                                <label style={{ marginRight: 10 }}>แหล่งท่องเที่ยว</label>
                                            </div>
                                            <div>
                                                <input type="radio" id="Locale5" name="Locale" value={this.state.Locale_an} style={{ marginRight: 5 }}
                                                    onChange={() => this.setState({ Locale_an: 'อื่นๆ' })} />
                                                <label style={{ marginRight: 10 }}>อื่นๆ</label>
                                                {this.state.Locale_an !== null && <input className="form-control" onChange={this.handleChange} ></input>}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                            {/* คำถามถามชมุชนน */}
                            {!this.state.cc && data.map((element, i) =>
                                <div key={i} className="boxcard" style={{ marginBottom: 10 }}>
                                    <div className="choice" >
                                        <p style={{ marginLeft: 20, width: '60%' }}>
                                            {element}
                                        </p>
                                        <Row style={{ marginLeft: 20, }}>
                                            <label style={{ marginLeft: 10, marginRight: 10 }}>
                                                <input type="radio" name={"ans" + i} value="1" style={{ marginRight: 5 }}
                                                    onChange={this.onChangeValue.bind(this, i, 1)} required />
                                                ใช่
                                            </label>
                                            <label style={{ marginLeft: 10, marginRight: 10 }} >
                                                <input type="radio" name={"ans" + i} value="0" style={{ marginRight: 5 }}
                                                    onChange={this.onChangeValue.bind(this, i, 0)} />
                                                ไม่ใช่
                                            </label>
                                        </Row>

                                    </div>

                                </div>

                            )}
                            <center style={{ marginBottom: 50, marginTop: 10 }}>
                                {this.state.cc ?
                                    <div>
                                        <button tyle="button" style={{ marginRight: 5 }} onClick={() => this.setState({ cc: false })} className="btn btn-success">
                                            ย้อนกลับ
                                        </button>
                                        <button tyle="submit" className="btn btn-success">
                                            จัดประเภท
                                        </button>
                                    </div>
                                    :
                                    <button tyle="button" onClick={this.check1.bind(this)} className="btn btn-success">
                                        ถัดไป
                                    </button>
                                }

                            </center>
                        </form>}

                </div>
            </div >
        )
    }
}

export default index
